import { Code } from "lucide-react";

import { WizardDefinition } from "../framework/types";
import { wizardMascots } from "../mascots/mascots";
import { INSTALL_SDK_WIZARD_TYPE } from "./constants";
import { firstEventForSite } from "./installEvent";
import { toSiteUrl } from "./siteUrl";
import { AddSnippetStep } from "./steps/AddSnippetStep";
import { VerifyEventsStep } from "./steps/VerifyEventsStep";
import { InstallSdkData } from "./types";

export const installSdkWizard: WizardDefinition<InstallSdkData, undefined> = {
  type: INSTALL_SDK_WIZARD_TYPE,
  title: "Install Freshpaint",
  description: "Add the Freshpaint snippet to your site and see events arrive",
  Icon: Code,
  mascot: wizardMascots[INSTALL_SDK_WIZARD_TYPE],
  searchKeys: ["install", "snippet", "sdk", "javascript", "tag", "setup"],
  createInitialData: () => ({ method: "head", siteUrl: "", firstEvent: null }),
  getCompletionSummary: (data) => {
    const firstEvent = firstEventForSite(
      data.firstEvent,
      toSiteUrl(data.siteUrl),
    );
    return firstEvent
      ? {
          title: "Freshpaint is installed",
          description:
            "Events from your site are arriving. Next, define your conversion events and connect your ad platforms.",
          highlights: [
            `First event: ${firstEvent.name || "Unnamed event"}`,
            ...(firstEvent.host ? [`Received from ${firstEvent.host}`] : []),
          ],
        }
      : {
          title: "Snippet added",
          description:
            "Freshpaint starts collecting events as soon as the snippet is live on your site. Check Live View to confirm.",
        };
  },
  useStepContext: () => undefined,
  steps: [
    {
      id: "add-snippet",
      phase: "Install",
      title: "Add the snippet",
      Component: AddSnippetStep,
    },
    {
      id: "verify",
      phase: "Validate",
      title: "Check events are arriving",
      Component: VerifyEventsStep,
    },
  ],
};
